import { AccountSettings } from "./components/AccountSettings";
import { GeneralSettings } from "./components/GeneralSettings";

export function SettingsPage({ isAdmin }: { isAdmin: boolean }) {
  return (
    <div className="space-y-10">
      <AccountSettings />
      {isAdmin && <GeneralSettings />}
    </div>
  );
}
